import { render, staticRenderFns } from "./ImageBottomSuction.vue?vue&type=template&id=edc1db52&scoped=true&"
import script from "./ImageBottomSuction.vue?vue&type=script&lang=js&"
export * from "./ImageBottomSuction.vue?vue&type=script&lang=js&"
import style0 from "./ImageBottomSuction.vue?vue&type=style&index=0&id=edc1db52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc1db52",
  null
  
)

export default component.exports